import {useAuthStore} from '@toolify/client/src/stores/AuthStore/useAuthStore'

import {$$, $computed} from '@vue-macros/reactivity-transform/macros'
import {IThemeVariables} from '@toolify/client/src/modules/theme/types/IThemeVariables'
import {ThemeType} from '@toolify/server/src/services/UserSettingsService/strategies/ThemeUserSettingStrategy/enum/ThemeType'
import {ThemeVariableType} from '@toolify/client/src/modules/theme/enum/ThemeVariableType'
import {ThemeTypeToThemeVariablesMap} from '@toolify/client/src/modules/theme/maps/ThemeTypeToThemeVariablesMap'
import {EntityType} from '@toolify/server/src/services/EntityService/enum/EntityType'
import {IUserResponseInstance} from '@toolify/server/src/adapters/InstanceApiResponseAdapter/types/responseInstances/IUserResponseInstance'
import {useGuestAppearance} from '@toolify/client/src/modules/authentication/composables/useGuestAppearance'

export function useThemeVariables() {
  const authStore = useAuthStore()
  const {theme: guestTheme} = useGuestAppearance()

  const currentTheme = $computed(() => {
    const user = authStore.currentEntity?.entityType === EntityType.User
      ? authStore.currentEntity.payload as IUserResponseInstance
      : null
    const theme = user
      ? user.settings?.theme
      : guestTheme.value
    if (!theme || !ThemeTypeToThemeVariablesMap.has(theme)) {
      return ThemeType.FiordNight
    }
    return theme
  })

  const themeVariables = $computed<IThemeVariables>(() => {
    return ThemeTypeToThemeVariablesMap.get(currentTheme)
  })

  // TODO: Remove computed
  const getThemeVariable = $computed<<T extends ThemeVariableType>(variableName: T) => IThemeVariables[T]>(() => {
    const variables = themeVariables
    return function<T extends ThemeVariableType>(variableName: T): IThemeVariables[T] {
      return variables?.[variableName]
    }
  })

  return $$({
    currentTheme,
    getThemeVariable,
  })
}
